import React from "react";
import I18n from "../../i18n/I18n";
import styles from "./FbnSettings.scss";
import { Icon, Button } from "../common/";

type Props = {
    options: Object,
    isLoading: boolean,
    post: Function,
};

const FbnSettings = (props: Props) => {
    const { data, isLoading, post } = props;

    const disableAccept = data ? data.is_accept_fbn_agreement === 1 : "";
    const disableForce = data ? data.force_is_fbn_eligible === 1 : "";
    return (
        <div className={styles.wrapper}>
            <div className={styles.ctr}>
                <div className={styles.box}>
                    <span className={styles.bold}>
                        {I18n.getText("settings.manage-fbn", {}, "MANAGE FBN")}
                    </span>
                </div>
                <div className={styles.box}>
                    <div>
                        <p className={styles.header}>
                            {I18n.getText(
                                "settings.terms-conditions",
                                {},
                                "Terms & Conditions"
                            )}
                        </p>
                        <p className={styles.bold}>
                            {I18n.getText("settings.accept-text")}
                        </p>
                    </div>
                    <Button
                        variant="primary"
                        onClick={() => post(false)}
                        disabled={disableAccept}
                    >
                        {isLoading ? (
                            <div className={styles.loader} />
                        ) : (
                            <div className={styles.btn}>
                                <Icon
                                    name="checkmark"
                                    className={styles.icon}
                                />
                                <div>
                                    {!disableAccept
                                        ? I18n.getText("settings.accept")
                                        : I18n.getText(
                                              "settings.accept-already"
                                          )}
                                </div>
                            </div>
                        )}
                    </Button>
                </div>
                <div className={styles.box}>
                    <div>
                        <p className={styles.header}>
                            {I18n.getText(
                                "settings.return-stock",
                                {},
                                "Return stock to FBN"
                            )}
                        </p>
                        <p className={styles.bold}>
                            {I18n.getText("settings.stock-fbn")}
                        </p>
                    </div>
                    <Button
                        variant="primary"
                        onClick={() => post(true)}
                        disabled={disableForce}
                    >
                        {isLoading ? (
                            <div className={styles.loader} />
                        ) : (
                            <div className={styles.btn}>
                                <Icon
                                    name="checkmark"
                                    className={styles.icon}
                                />
                                <div>
                                    {!disableForce
                                        ? I18n.getText("settings.accept")
                                        : I18n.getText(
                                              "settings.accept-already"
                                          )}
                                </div>
                            </div>
                        )}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default FbnSettings;



// WEBPACK FOOTER //
// ./src/components/settings/FbnSettings.js